export const SET_ALL_AWARD_UNITS = "Setzt alle AwardUnits";
export const SET_CURRENT_AWARD_UNIT = "Setzt den/das aktuelle AwardUnit";

export const SET_LOCK = "Setze das Award Unit Lock";
